@if (loading && isCdcAvailable()) {
  <div class="container h-100">
    <div class="start-animation row h-100 justify-content-center align-items-center flex-column">
      <div class="navbar-brand"></div>
      <div class="loader"></div>
    </div>
  </div>
} @else if (isCdcAvailable()) {
  <router-outlet></router-outlet>
}
<app-global-footer></app-global-footer>

<!-- main system notifications -->
<section *ngIf="mainNotifications?.length > 0" class="user-info-notice">
  <div class="container">
    <div class="d-flex gap-3">
        <div class="d-flex flex-column">
          <div *ngFor="let notification of mainNotifications; index as i">
            <div  class="d-flex gap-2">
            <app-svg-icon type="information_circle"/>
            <div [innerHTML]="getNotificationText(notification)"></div>
            </div>
            <hr *ngIf="i < (mainNotifications.length - 1)" class="separator my-3">
          </div>
        </div>

        <div class="d-flex flex-column gap-2" [style.min-width]="'180px'">
          <button (click)=closeNotifications(); class="btn btn-secondary">Close</button>
          <button *ngIf="hasTemporaryMainNotifications" (click)=confirmNotifications(); class="btn btn-primary">O.K.</button>
        </div>

    </div>
  </div>
</section>
